import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { ControlContainer, NgForm } from '@angular/forms';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import DateHelpers from '../../../_infrastructure/DateHelpers';

@Component({
    selector: 'incapacity-evaluation',
    templateUrl: './incapacity-evaluation.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class IncapacityEvaluationComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.ClinicalEvaluationVM = {} as models.ClinicalEvaluationVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public isWorkflowPgpv: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.videoCallLocations)
  public videocallLocations: models.DimensionVM[];

  public currentDate: Date = new Date();
  public currentMaxDate: Date = new Date();

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    //set currentMaxDate
    this.currentMaxDate.setDate(this.currentMaxDate.getDate() + 30);
  }

  ngOnDestroy(): void {
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }
}
